import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FaSearch } from 'react-icons/fa';
import { MdPlaylistAdd } from 'react-icons/md';
import {
  clearCotation,
  getManufacturers,
  getModels
} from '../../actions/cotation';
import { Typeahead } from 'react-bootstrap-typeahead';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PH_MARQUE = 'Fabricant';
const PH_MODELE = 'Modèle';

const RechercheCotation = ({
  clearCotation,
  getManufacturers,
  getModels,
  auth,
  cotation: { distinctManufacturer, distinctModel, loading }
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    getManufacturers();
  }, [clearCotation, getManufacturers]);

  // on aurait put avoir un tab de tab pour selectionArray et se passer de singleSelections, mais l'un doit etre null au debut et l'autre tjrs remplie au moins azvec PH
  //On se sert des PH juste pour avoir une majuscule au chargement de la page, sinon inutile
  const [selectionArray, setSelectionArray] = useState([PH_MARQUE, PH_MODELE]);
  const [singleSelections, setSingleSelections] = useState([[], []]);

  function onSelection(tab, index) {
    let arrayTampon = [...singleSelections];
    arrayTampon[index] = tab;
    setSingleSelections(arrayTampon);
    let newArr = [...selectionArray];
    tab.length > 0 ? (newArr[index] = tab[0]) : (newArr[index] = 'placeholder');
    setSelectionArray(newArr); //ne peut pas avoir des elts null

    if (newArr[0] !== PH_MARQUE && newArr[0] !== 'placeholder') {
      getModels(newArr[0]);
    }

    // getDistinctRefreshAll(
    //   newArr[0] !== PH_MARQUE && newArr[0] !== listparam[0]
    //     ? newArr[0]
    //     : undefined,
    //   newArr[1] !== PH_MODELE && newArr[1] !== listparam[1]
    //     ? newArr[1]
    //     : undefined
    // );
  }

  const navigate = useNavigate();

  const routeChange = () => {
    console.log('selectionArray used', selectionArray);
    if (selectionArray[0] !== PH_MARQUE || selectionArray[1] !== PH_MODELE) {
      let path =
        `/cotations/` +
        (selectionArray[0] !== PH_MARQUE
          ? `${encodeURIComponent(selectionArray[0])}/`
          : `null/`) +
        (selectionArray[1] !== PH_MODELE
          ? `${encodeURIComponent(selectionArray[1])}/`
          : `null/`);
      navigate(path);
    }
  };

  useEffect(() => {
    const listener = (event) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        console.log('Enter key was pressed. Run your function.');
        event.preventDefault();
        routeChange();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [selectionArray]);

  //Suppression du spinner sur loading pour eviter de refresh la page quand on debute l'effacement d'un element dans le typeahaed
  if (distinctManufacturer.length === 0) {
    return <Spinner />;
  } else {
    return (
      <section className="container">
        <div>
          <h2 className="p-3 mb-2 bg-ascorel text-white text-center">
            Recherche cotation
          </h2>
          <div className="row text-center" style={{ marginTop: 30 }}>
            <div className="row  col-xs-6" style={{ margin: 10 }}>
              <div>
                <Typeahead
                  style={{ margin: 10 }}
                  id={`${'manufacturer'}`}
                  labelKey={'manufacturer'}
                  onChange={(tab) => onSelection(tab, 0)}
                  options={distinctManufacturer}
                  placeholder={selectionArray[0]}
                  selected={singleSelections[0]}
                />
              </div>
              <div>
                <Typeahead
                  style={{ margin: 10 }}
                  id={`${'model'}`}
                  labelKey={'model'}
                  onChange={(tab) => onSelection(tab, 1)}
                  options={distinctModel}
                  placeholder={selectionArray[1]}
                  selected={singleSelections[1]}
                />
              </div>
            </div>

            <div className=" text-center col-xs-6" style={{ margin: 10 }}>
              {/* la partie .replace('/','|||') permet de filtrer les caracters / et de les remplacer poar des caracters ||| d'echaeppement, pour eviter les pb d'url
          on recupere ensuite ||| dans la page resultat et on le retransforme en / avant de lancer le get fichegrue*/}
              <div className="row">
                <div className="col text-center">
                  <button
                    className="btn btn-ascorel btn-lg"
                    onClick={routeChange}
                  >
                    {t('rechercher')}
                    <FaSearch />
                  </button>

                  <Link to="/create-cotation" className="text-navbar">
                    <button className="btn btn-ascorel btn-lg ">
                      {t('create_new_cotation')} <MdPlaylistAdd />
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

RechercheCotation.propTypes = {
  clearCotation: PropTypes.func.isRequired,
  getManufacturers: PropTypes.func.isRequired,
  getModels: PropTypes.func.isRequired,
  cotation: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  cotation: state.cotation
});

export default connect(mapStateToProps, {
  clearCotation,
  getManufacturers,
  getModels
})(RechercheCotation);

const btnStyle = {
  margin: '8px',
  padding: '8px'
};
